import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"

import { StyledContainer } from "../containers/index"

const StyledImagesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 24px;
  margin: 24px 0 64px;
  text-align: center;

  p {
    margin-top: 12px;
  }

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    grid-template-columns: 1fr;
  }
`

const ImagesGrid = ({ images }) => {
  return (
    <StyledContainer>
      <StyledImagesGrid>
        {images.map(({ image, image_description }) => {
          return (
            <div key={image_description}>
              <Img
                fluid={image.localFile.childImageSharp.fluid}
                alt={image.alt}
              />
              <p>{image_description}</p>
            </div>
          )
        })}
      </StyledImagesGrid>
    </StyledContainer>
  )
}

export default ImagesGrid
